import {
  CLINIC_LIST,
  ADD_CLINIC,
  REMOVE_CLINIC,
  USERS_CLINIC,
  REMOVE_USER_CLINIC,
  REMOVE_PAITENT_CLINIC,
  GET_CLINIC_DETAILS,
  PATIENTS_LIST,
  SET_ALL_PATIENTS,
  SET_ALL_ADMINS

} from "../actions/types";

const initialState = {
  clinicList: [],
  selectedClinic: null,
  usersClinic: [],
  patientsList: [],
  error:"",
  errorModal:"",
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ALL_ADMINS:
      return { ...state, usersClinic: payload };
    case SET_ALL_PATIENTS:
      return { ...state, patientsList: payload };
    case PATIENTS_LIST:
      return { ...state, patientsList: payload };

    case USERS_CLINIC:
      return { ...state, usersClinic: payload };
    case CLINIC_LIST:
      return { ...state, clinicList: payload };
    case ADD_CLINIC:
      return { ...state, clinicList: [...state.clinicList, payload] };
    case REMOVE_CLINIC:
      console.log("REMOVE_CLINIC");
      console.log({ payload });
      const updatedClinicsRem = state.clinicList.filter(
        (clinic) => clinic.id !== payload && clinic
      );
      console.log({ updatedClinicsRem });
      return { ...state, clinicList: [...updatedClinicsRem] };
    case REMOVE_USER_CLINIC:
      console.log("REMOVE_USER_CLINIC");
      console.log({ payload });
      const updatedUserList = state.usersClinic.filter(
        (user) => user.id !== payload && user
      );
      console.log({ updatedUserList });
      return { ...state, usersClinic: [...updatedUserList] };
    case REMOVE_PAITENT_CLINIC:
      console.log("REMOVE_PAITENT_CLINIC");
      console.log({ payload });
      const updatedPaitentList = state.patientsList.filter(
        (user) => user.id !== payload && user
      );
      console.log({ updatedPaitentList });
      return { ...state, patientsList: [...updatedPaitentList] };


    case GET_CLINIC_DETAILS:
      console.log("GET_CLINIC_DETAILS", payload);
      return { ...state, selectedClinic: payload };



    default:
      return state;
  }
};
